/*
 * The audio batch views english translation
 */
export const AUDIO_BATCH_VIEW_EN = {
  uploadYourAudioFiles: 'Upload your audio files',
  uploadAudioFilesExplainationLine1: 'Please upload audio files for transcription.',
  uploadAudioFilesExplainationLine2:
    'Valid file types: flac, mp3, mpeg, mpga, m4a, ogg, wav, webm. Maximum file size: 100MB per file.',
  transcribeAll: 'Transcribe all',
  transcriptions: 'Transcriptions',
  progress: 'Progress',
  copyAll: 'Copy all'
}
/*
 * The audio batch views german translation
 */
export const AUDIO_BATCH_VIEW_DE = {
  uploadYourAudioFiles: 'Audio-Dateien hochladen',
  uploadAudioFilesExplainationLine1: 'Lade deine Audio-Dateien zur Transkription hoch.',
  uploadAudioFilesExplainationLine2:
    'Unterstützte Formate: flac, mp3, mpeg, mpga, m4a, ogg, wav, webm. Maximale Größe: 100MB pro Datei.',
  transcribeAll: 'Alle transkribieren',
  transcriptions: 'Transkriptionen',
  progress: 'Fortschritt',
  copyAll: 'Alle kopieren'
}
